import store from '@/store/index.js'
import DashboardTypes from '@/assets/enums/dashboard/DashboardTypes.js'

const TheAllTasksIndexPage = () =>
  import('@/views/taskDossier/index/TheAllTaskDossierIndexPage')

export const tasksSubPages = [
  {
    path: 'dashboard-tasks',
    children: [
      {
        path: '',
        name: 'task_page_route',
        component: () =>
          import('@/views/taskDossier/index/TheTasksIndexPage.vue'),
        meta: {
          route_name: 'task_dashboard_route_id'
        },
        children: [
          {
            path: '',
            beforeEnter: (from, to, next) => {
              let template = store.getters[
                'metadata/getTemplateDashboardByType'
              ](DashboardTypes.TASK)
              if (Array.isArray(template) && template[0]) {
                next({
                  name: 'task_dashboard_route_id',
                  params: { id: template[0].id }
                })
                return
              }
              next()
              return
            }
          },
          {
            path: ':id',
            name: 'task_dashboard_route_id',
            component: () =>
              import('@/views/taskDossier/index/TheTasksIndexPage.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/task-dossier',
    name: 'tasks_index_route',
    component: TheAllTasksIndexPage
  }
]
